export default theme => ({
  root: {
    position: 'fixed',
    top: 0,
    left: 0,
    boxSizing: 'border-box',
    width: 64,
    height: '100vh',
    display: 'flex',
    flexFlow: 'column nowrap',
    transition: 'width .4s cubic-bezier(0, 0, 0.3, 1)',
    willChange: 'width',
    backfaceVisibility: 'hidden',
    '& *': {
      boxSizing: 'border-box'
    }
  },
  brand: {
    display: 'flex',
    flex: '0 1 64px',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: '24px 0 20px 16px',
    marginRight: '16px'
  },
  divider: {
    display: 'block',
    width: '100%',
    minWidth: 40,
    height: 0,
    borderTop: `1px solid ${theme.colors.actionMinor[300]}`,
    margin: '4px auto',
    transition: 'all .4s cubic-bezier(0, 0, 0.3, 1)'
  },
  inner: {
    display: 'flex',
    flex: 1,
    flexFlow: 'column nowrap',
    maxHeight: '100%'
  },
  menuContainer: {
    height: 'calc(100% - 64px)',
    display: 'flex',
    flexDirection: 'column',
    alignContent: 'space-between'
  },
  menu: {
    flex: 1,
    overflow: 'auto',
    '&::-webkit-scrollbar': {
      width: 10,
      height: 10
    },
    '&::-webkit-scrollbar-thumb': {
      borderRadius: 10,
      background: theme.colors.grey[700],
      backgroundClip: 'content-box',
      border: '4px solid rgba(0, 0, 0, 0)'
    },
    '&::-webkit-scrollbar-thumb:window-inactive': {
      borderRadius: 10,
      background: theme.colors.grey[700],
      backgroundClip: 'content-box',
      border: '4px solid rgba(0, 0, 0, 0)'
    }
  },
  menuInner: {
    padding: '8px 12px',
    overflow: 'hidden'
  },
  menuTooltip: {
    position: 'absolute',
    top: 0,
    left: '100%',
    willChange: 'opacity, transform',
    transform: 'translate3d(0, 0, 0)',
    transition: 'transform .2s cubic-bezier(0, 0, 0.3, 1)'
  },
  postComponent: {
    display: 'flex',
    alignContent: 'center'
  },
  toggleSidebar: {
    position: 'absolute',
    top: 16,
    right: -16,
    opacity: 0,
    transition: 'all .2s ease'
  },
  tooltipTransition: {
    '&.tooltip-transition-enter': {
      opacity: 0
    },
    '&.tooltip-transition-enter-active': {
      opacity: 1,
      transition: 'opacity .2s ease-in'
    },
    '&.tooltip-transition-exit': {
      opacity: 1
    },
    '&.tooltip-transition-exit-active': {
      opacity: 0,
      transition: 'opacity .2s ease-in'
    }
  },
  isHover: {
    '& $toggleSidebar': {
      opacity: 1
    }
  },
  isExpanded: {
    width: 224
    // '& $divider': {
    //     width: '100%',
    // },
  }
});